import {httpService} from "@/services/HttpService";

class UserService {
    invite(personRef: string): Promise<{ code: InviteResponseCode }> {
        return httpService.post(`/user/${personRef}/invite`, {})
    }

    getAcceptStatus(personRef: string): Promise<{ code: UserLoginAcceptStatus }> {
        return httpService.get(`/user/${personRef}/accept-status`)
    }

    accept(personRef: string, password: string): Promise<{
        code: UserLoginAcceptedCode,
        username: string | undefined
    }> {
        return httpService.post(`/user/${personRef}/accept`, {password: password})
    }
}

export enum InviteResponseCode {
    SUCCESS = "SUCCESS",
    USERNAME_ALREADY_IN_USE = "USERNAME_ALREADY_IN_USE",
    PERSON_ALREADY_HAS_LOGIN = "PERSON_ALREADY_HAS_LOGIN"
}

export enum UserLoginAcceptedCode {
    SUCCESS = "SUCCESS",
    PERSON_HAS_NO_LOGIN = "PERSON_HAS_NO_LOGIN",
    PERSON_ALREADY_HAS_PASSWORD = "PERSON_ALREADY_HAS_PASSWORD"
}

export enum UserLoginAcceptStatus {
    UNKNOWN = "UNKNOWN",
    CAN_ACCEPT = "CAN_ACCEPT",
    USERNAME_INVALID = "USERNAME_INVALID",
    PERSON_BLOCKED = "PERSON_BLOCKED",
    PERSON_DOES_NOT_EXIST = "PERSON_DOES_NOT_EXIST",
    PERSON_ALREADY_HAS_LOGIN = "PERSON_ALREADY_HAS_LOGIN"
}

export const userService = new UserService();
